var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"dense":"","color":"grey lighten-4"}},[_c('v-list-item-group',[_c('v-list-item',[_vm._v(" A "+_vm._s(_vm.session.location)+" du "+_vm._s(_vm.session.start)+" au "+_vm._s(_vm.session.end))]),_c('v-list-item',[_vm._v(" Statut : "+_vm._s(_vm.session.status))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }